import { cn } from "@/lib/utils";
import type { CustomJobDetailDTO } from "@/modules/custom-jobs/domain/types";
import { formatDateLocal, formatDateTimeLocal } from "@/shared/lib/date-time";

function MetaField({
  label,
  value,
  warn,
  destructive,
}: {
  label: string;
  value: string;
  warn?: boolean;
  destructive?: boolean;
}) {
  return (
    <div
      className={cn(
        "rounded-xl border px-3 py-2.5",
        warn && "border-destructive/25 bg-destructive/5",
        destructive && "border-destructive/25 bg-destructive/5",
        !warn && !destructive && "border-border/50 bg-muted/20",
      )}
    >
      <p className="text-[11px] text-muted-foreground uppercase tracking-wide">
        {label}
      </p>
      <p
        className={cn(
          "mt-0.5 font-medium text-sm",
          destructive && "text-destructive",
        )}
      >
        {value}
      </p>
    </div>
  );
}

export function CustomJobTimelinePanel({ job }: { job: CustomJobDetailDTO }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <MetaField label="ສ້າງ" value={formatDateTimeLocal(job.createdAt)} />
      {job.confirmedAt ? (
        <MetaField label="ຢືນຢັນ" value={formatDateTimeLocal(job.confirmedAt)} />
      ) : null}
      {job.startedAt ? (
        <MetaField label="ເລີ່ມເຮັດ" value={formatDateTimeLocal(job.startedAt)} />
      ) : null}
      {job.readyAt ? (
        <MetaField label="ພ້ອມຮັບ" value={formatDateTimeLocal(job.readyAt)} />
      ) : null}
      {job.completedAt ? (
        <MetaField label="ສົ່ງມອບ" value={formatDateTimeLocal(job.completedAt)} />
      ) : null}
      {job.paidAt ? (
        <MetaField label="ຮັບເງິນ" value={formatDateTimeLocal(job.paidAt)} />
      ) : null}
      {job.dueDate ? (
        <MetaField
          label="ວັນນັດຮັບ"
          value={formatDateLocal(job.dueDate)}
          warn={
            job.status !== "completed" &&
            job.status !== "cancelled" &&
            job.dueDate < new Date().toISOString().slice(0, 10)
          }
        />
      ) : null}
      {job.cancelledAt ? (
        <MetaField
          label="ຍົກເລີກ"
          value={formatDateTimeLocal(job.cancelledAt)}
          destructive
        />
      ) : null}
    </div>
  );
}
